// The rejections of POST /v1/donors/{uid}/donation-site (409 body `error`)
// that «Giverdetaljer» explains itself:
// - CMT-57: the donor still has an unresolved booking;
// - CMT-87: «Bytt tappested» is not switched on for the donor's HF (sysadmin
//   enables it per helseforetak; the server checks it before anything else,
//   even before the `unchanged` case).
export const ACTIVE_BOOKING_EXISTS = 'active_booking_exists';
export const FEATURE_DISABLED = 'feature_disabled';

export const DONORS_HEADINGS = {
  NAME: 'name',
  ID_NUMBER: 'ID_number',
  LAST_DRAW: 'last_draw',
  BLOOD_TYPE: 'blood_type',
  TITER: 'titer',
  DONOR_STATUS: 'donor_status',
  DONOR_TYPE: 'donor_type',
  QUARANTINE_DUE_DATE: 'quarantine_due_date',
  APP_USER: 'app_user',
  SMS: 'sms',
  NEXT_APPOINTMENT: 'next_appointment',
};

export const DONORS_SETUP = [
  {
    title: DONORS_HEADINGS.DONOR_STATUS,
    isSortable: true,
    isHighlighted: true,
    isTextOwerflowHidden: false,
  },
  {
    title: DONORS_HEADINGS.BLOOD_TYPE,
    isSortable: true,
    isHighlighted: true,
    isTextOwerflowHidden: false,
  },
  {
    title: DONORS_HEADINGS.TITER,
    isSortable: true,
    isHighlighted: false,
    isTextOwerflowHidden: false,
  },
  {
    title: DONORS_HEADINGS.APP_USER,
    isSortable: true,
    isHighlighted: false,
    isTextOwerflowHidden: false,
  },
  {
    title: DONORS_HEADINGS.SMS,
    isSortable: true,
    isHighlighted: false,
    isTextOwerflowHidden: false,
  },
  {
    title: DONORS_HEADINGS.LAST_DRAW,
    isSortable: true,
    isHighlighted: false,
    isTextOwerflowHidden: false,
  },
  {
    title: DONORS_HEADINGS.QUARANTINE_DUE_DATE,
    isSortable: true,
    isHighlighted: false,
    isTextOwerflowHidden: false,
  },
  {
    title: DONORS_HEADINGS.NEXT_APPOINTMENT,
    isSortable: true,
    isHighlighted: false,
    isTextOwerflowHidden: true,
  },
];

// Sort keys POST /v1/donors/batch-get accepts (`sort`), one per table
// column — the column titles above double as the keys. The list loads
// sorted by next appointment, soonest first.
export const DONORS_SORT_KEYS = [
  'id',
  DONORS_HEADINGS.DONOR_STATUS,
  DONORS_HEADINGS.BLOOD_TYPE,
  DONORS_HEADINGS.TITER,
  DONORS_HEADINGS.APP_USER,
  DONORS_HEADINGS.SMS,
  DONORS_HEADINGS.LAST_DRAW,
  DONORS_HEADINGS.QUARANTINE_DUE_DATE,
  DONORS_HEADINGS.NEXT_APPOINTMENT,
];

export const DONORS_DEFAULT_SORT = { key: DONORS_HEADINGS.NEXT_APPOINTMENT, order: 'asc' };

export const DONORS_LIST = [
  {
    [DONORS_HEADINGS.NAME]: 'Mia Skagestad',
    [DONORS_HEADINGS.ID_NUMBER]: 264758693657,
    [DONORS_HEADINGS.LAST_DRAW]: '12 January 2020',
    [DONORS_HEADINGS.BLOOD_TYPE]: '0+',
    [DONORS_HEADINGS.DONOR_STATUS]: 'New',
    [DONORS_HEADINGS.DONOR_TYPE]: 'Full blood',
    [DONORS_HEADINGS.QUARANTINE_DUE_DATE]: '25 January 2020',
    [DONORS_HEADINGS.NEXT_APPOINTMENT]: '30 January 2022'
  },
];
